<template>
  <de-layout-content :isCard="true">
    <div class="access">
      <a-card style="width: 100%" :tab-list="tabList" :active-tab-key="activeTabKey"
        @tabChange="(key) => onTabChange(key, 'key')">
        <template #customRender="item">
          {{ item.key }}
        </template>
        <div v-if="activeTabKey == 'tab1'" class="device">
          <div class="tree deviceAccessTree">
            <div>
              <group ref="groupCom" :current-node-id="currentNodeId" :group-type="sjjr"
                @switchComponent="switchComponent" />
            </div>
            <div>
              <el-button type="primary" v-if="userRole != 'SPORT_CENTER_ADMIN'" @click="skipPage('deviceAdd')">新增数据接入</el-button>
            </div>
          </div>
          <div class="tab" v-if="param">
            <!-- <div> -->
            <div class="deviceInfo">
              <div class="name">{{deviceParam.deviceName}}</div>
              <el-row v-if="userRole != 'ADMIN'" class="mt10">
                <el-col :span="8">
                  <div class="option">数据源获取方式：{{dataType[deviceParam.dataGet]}}</div>
                </el-col>
                <el-col :span="8">
                  <div class="option">接入来源：{{deviceParam.companyName || '--'}}</div>
                </el-col>
                <el-col :span="8">
                  <div class="option">说明：{{deviceParam.remark || '--'}}</div>
                </el-col>
              </el-row>
            </div>
            <a-tabs :activeKey="activeKey" @change="tabChange" class="tabs_pane_line">
              <a-tab-pane key="1" tab="数据字段">
                <a-table :loading="loading" :dataSource="dataSource" :columns="columns" :rowKey="(item) => item.id"
                  @change="tableChange">
                </a-table>
              </a-tab-pane>
              <a-tab-pane key="2" tab="变更记录" force-render v-if="userRole == 'ADMIN'">
                <a-form layout="inline" autocomplete="off">
                  <a-form-item label="变更内容" class="width-normal">
                    <a-input v-model="recordValue" placeholder="请输入内容" style="min-width: 229px" />
                  </a-form-item>
                  <a-form-item class="width-small">
                    <a-space :size="8">
                      <a-button type="primary" @click="getDeviceInfoEditList()"><i class="el-icon-search"></i>
                        查询</a-button>
                      <a-button type="default" @click="getDeviceInfoEditList(1)"><i class="el-icon-refresh"></i>
                        重置</a-button>
                    </a-space>
                  </a-form-item>
                </a-form>
                <a-table :loading="loading" :dataSource="dataSourceTwo" :columns="columns1" :rowKey="(item) => item.id"
                  :pagination="pagination" @change="tableChange">
                </a-table>
              </a-tab-pane>
              <a-tab-pane key="3" tab="数据接入配置" v-if="userRole == 'ADMIN'">
                <from-dom componentsType="edit" :deviceId="param.deviceId" :activeKey="activeKey" @init="init" />
              </a-tab-pane>
              <a-button slot="tabBarExtraContent" icon="plus" type="primary" size="mini"
                @click="indexModalVisible = true" v-if="userRole == 'ADMIN'">
                选择指标
              </a-button>
            </a-tabs>
            <!-- </div> -->
          </div>
        </div>
        <client-list v-else />
      </a-card>
    </div>
    <index-modal :visible="indexModalVisible" @cancel="cancelIndexModal"  :deviceParam="deviceParam" />
  </de-layout-content>
</template>

<script>
import indexModal from "./indexModal.vue";
import ClientList from "./clientList.vue";
import FromDom from "./fromDom.vue";
import * as API_Ques from "@/api/dataAccess/accessApi";
import { fieldListDQ } from "@/api/dataset/dataset";
import moment from "moment";
import Group from "../group/Group";
export default {
  components: {
    // Topic
    Group,
    ClientList,
    FromDom,
    indexModal,
  },
  data() {
    return {
      param: null, //树状列表返回选中的值
      deviceParam: {},
      loading: false,
      tabList: [
        {
          key: "tab1",
          tab: "设备列表",
        },
        {
          key: "tab2",
          tab: "客户授权",
        },
      ],
      activeKey: "1",
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "30", "40", "50"],
        showTotal: (total) => `共有 ${total} 条数据`, //分页中显示总的数据
      },
      columns: [
        {
          title: "序号",
          dataIndex: "a1",
          key: "a1",
          width: 80,
          customCell: (row, index) => {
            return {
              style: {
                textAlign: "center", //对齐方式
              },
            };
          },
          fixed: "left",
          customRender: (text, record, index) => `${index + 1}`,
        },
        {
          title: "指标名称",
          dataIndex: "name",
          key: "name",
          customCell: (row, index) => {
            return {
              style: {
                textAlign: "center", //对齐方式
              },
            };
          },
        },
        {
          title: "指标类型",
          dataIndex: "type",
          key: "type",
          customCell: (row, index) => {
            return {
              style: {
                textAlign: "center", //对齐方式
              },
            };
          },
        },
        {
          title: "说明",
          dataIndex: "remark",
          key: "remark",
          width: 320,
          customCell: (row, index) => {
            return {
              style: {
                textAlign: "center", //对齐方式
              },
            };
          },
        },
        {
          title: "指标默认值",
          dataIndex: "fieldDefault",
          key: "fieldDefault",
          customCell: (row, index) => {
            return {
              style: {
                textAlign: "center", //对齐方式
              },
            };
          },
        },
      ],
      columns1: [
        {
          title: "序号",
          dataIndex: "a1",
          key: "a1",
          width: 80,
          fixed: "left",
          customCell: () => {
            return {
              style: {
                textAlign: "center", //对齐方式
              },
            };
          },
          customRender: (text, record, index) => {
            return index + 1;
          },
        },
        {
          title: "变更内容",
          dataIndex: "content",
          key: "content",
          customCell: () => {
            return {
              style: {
                textAlign: "center", //对齐方式
              },
            };
          },
        },
        {
          title: "变更时间",
          dataIndex: "time",
          key: "time",
          width: 320,
          customCell: () => {
            return {
              style: {
                textAlign: "center", //对齐方式
              },
            };
          },
        },
      ],
      activeTabKey: "tab1",
      treeList: [],
      dataSource: [],
      dataSourceTwo: [],
      form: {
        content: "",
      },
      searchValue: "",
      recordValue: "", //变更列表查询条件
      defaultProps: {
        children: "children",
        label: "label",
      },
      indexModalVisible: false, //指标弹窗标志
      userRole: null,
      dataType: {
        '1': 'API',
        '2': '数据库',
        '3': '蓝牙',
        '4': 'EXCEL/CSV',
      }
    };
  },
  computed: {
    currentNodeId() {
      return this.param?.id;
    },
  },
  created() {
    const that = this;
    this.userRole = (this.$store.state.user.roles.length && this.$store.state.user.roles[0].name) || "";
    console.log(this.userRole,'userRole');
    if (this.userRole == "ADMIN") {
      this.tabList = [
        {
          key: "tab1",
          tab: "设备列表",
        },
        {
          key: "tab2",
          tab: "客户列表",
        },
      ];
    } else {
      this.tabList = [
        {
          key: "tab1",
          tab: "设备列表",
        },
      ];
    }
  },
  methods: {
    onTabChange(value, type) {
      if (type === "key") {
        this.activeTabKey = value;
      }
    },
    switchComponent(c) {
      // console.log(c)
      if (!c.param) {
        // 树结构没有数据，不需要调接口
        return false;
      }
      const { deviceId } = c.param;
      this.deviceParam = c.param
      // console.log(this.deviceParam);
      this.param = {
        ...c.param,
        deviceInfoId: deviceId,
        deviceId,
      };
      if (this.activeKey == 1) {
        this.getDeviceFieldList();
      }
      if (this.activeKey == 2) {
        this.getDeviceInfoEditList();
      }
    },
    // 列表页卡片切换
    tabChange(key) {
      if (this.activeKey == key) return false;
      this.activeKey = key;
      this.pagination = {
        ...this.pagination,
        ...{
          current: 1,
          pageSize: 10,
        },
      };
      this.recordValue = null;
      if (key == 1) {
        this.getDeviceFieldList();
      }
      if (key == 2) {
        this.getDeviceInfoEditList();
      }
    },
    tableChange(paginationData) {
      this.pagination = paginationData;
      if (this.activeKey == 1) {
        this.getDeviceFieldList();
      }
      if (this.activeKey == 2) {
        this.getDeviceInfoEditList();
      }
    },
    // 数据字段列表
    getDeviceFieldList() {
      this.dataSource = []
      // const { current, pageSize } = this.pagination;
      // const param = {
      //   current,
      //   pageSize,
      //   deviceInfoId: this.param.deviceInfoId,
      // };
      // console.log(this.deviceParam);
      // console.log(this.deviceParam.datasetTableId);
      if(this.deviceParam.datasetTableId) {
        this.loading = true;
        fieldListDQ(this.deviceParam.datasetTableId)
        .then((res) => {
          this.loading = false;
          this.dataSource = res.data.quotaList;
        })
        .catch((err) => {
          this.loading = false;
        });
      }

    },
    // 变更记录列表
    getDeviceInfoEditList(type) {
      if (type) {
        this.recordValue = "";
        this.pagination = {
          ...this.pagination,
          ...{
            current: 1,
            pageSize: 10,
          },
        };
      }
      const { current, pageSize } = this.pagination;
      // console.log(this.recordValue)
      const param = {
        content: this.recordValue,
        deviceId: this.param.deviceId,
        current,
        pageSize,
      };
      this.loading = true;
      API_Ques.deviceInfoEditList(param)
        .then((res) => {
          this.loading = false;
          const { code, msg, data } = res;
          if (code == 0 || code == 200) {
            for (let i = 0; i < data.list.length; i++) {
              data.list[i].time = moment(data.list[i].time).format("YYYY-MM-DD")
            }
            this.dataSourceTwo = data.list;

            return false;
          }
          this.$message.error(msg || "接口异常，请联系管理员");
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error(err || "接口异常，请联系管理员！");
        });
    },
    // 关闭指标弹窗
    cancelIndexModal(e) {
      // console.log(e);
      this.indexModalVisible = false;
      if(e) {
        // 通过子组件专递过来的值，更改父组件的datasetTableId
        this.deviceParam.datasetTableId = e
        this.getDeviceFieldList();
      }
    },
    // 跳转新增数据接入
    skipPage(name) {
      this.$router.push({
        name,
      });
    },
    init() {
      this.activeKey = "1"
      this.$refs.groupCom.init(true)
    }
  },
  watch: {
    searchValue(val) {
      this.$refs.tree.filter(val);
    },
  },
};
</script>

<style lang="less" scoped>
.device {
  display: flex;

  .tree {
    width: 15%;
    border-right: 1px solid #ddd;
    box-sizing: border-box;
    padding: 15px 15px 15px 0;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-direction: column;
  }

  .tab {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    height: 100%;
    padding: 15px 0 15px 15px;
    ::v-deep .ant-tabs {
      flex: 1;
      min-height: 0;
      .ant-tabs-top-content {
        height: calc(100% - 60px)
      }
      .ant-tabs-top-content > .ant-tabs-tabpane {
        height: 100%;
      }
    }
    .deviceInfo {
      padding: 24px;
      background: #21284B;
      margin-bottom: 15px;
      .name {
        font-size: 18px;
      }
    }
  }
}

::v-deep.ant-table-thead>tr>th {
  text-align: center;
}

// ant-card ant-card-bordered ant-card-contain-tabs
::v-deep.ant-card-body {
  padding: 0 24px !important;
}

.tree {
  position: relative;

  .btn {
    position: absolute;
    bottom: 20px;
    left: 20%;
  }
}

::v-deep.access {
  height: 100%;
  background-color: #141937;

  &>.ant-card {
    display: flex;
    flex-direction: column;
    height: 100%;
    background: inherit !important;
    border: 0 !important;

    .ant-card-head {
      border-bottom: 1px solid rgba(255, 255, 255, 0.1) !important;

      .ant-tabs-bar {
        border-bottom: 1px solid rgba(255, 255, 255, 0.1) !important;
      }
    }

    .ant-card-body {
      flex: 1;
      min-height: 0;
    }

    .device {
      height: 100%;

      .tree {
        border-right: 1px solid rgba(255, 255, 255, 0.1) !important;
      }

      .tab {
        .ant-tabs {
          .ant-tabs-bar {
            border-bottom: 1px solid rgba(255, 255, 255, 0.1);
          }
        }
      }
    }
  }
}

::v-deep .deviceAccessTree {
  .el-tree-node__children {
    .el-tree-node__content {
      padding-left: 0;

      .el-icon-caret-right {
        color: rgba(255, 255, 255, .5);
      }

      .custom-tree-node-list {
        padding-right: 0 !important;
        padding-left: 0 !important;

        .de-fill-block {
          margin-left: 0 !important;
        }
      }
    }
  }
}
</style>
